import { render, staticRenderFns } from "./coponent1.vue?vue&type=template&id=10b8f9cf&scoped=true&"
import script from "./coponent1.vue?vue&type=script&lang=js&"
export * from "./coponent1.vue?vue&type=script&lang=js&"
import style0 from "./coponent1.vue?vue&type=style&index=0&id=10b8f9cf&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./coponent1.vue?vue&type=style&index=1&id=10b8f9cf&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style2 from "./coponent1.vue?vue&type=style&index=2&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b8f9cf",
  null
  
)

export default component.exports